import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Coins = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M8 11.4C8 12.17 8.6 12.8 9.33 12.8H10.83C11.47 12.8 11.99 12.25 11.99 11.58C11.99 10.85 11.67 10.59 11.2 10.42L8.8 9.58C8.32 9.41 8 9.15 8 8.42C8 7.75 8.52 7.2 9.16 7.2H10.66C11.4 7.21 12 7.83 12 8.6M10 12.85V13.59M10 6.41V7.19M12.9805 19.88C13.8805 21.15 15.3505 21.98 17.0305 21.98C19.7605 21.98 21.9805 19.76 21.9805 17.03C21.9805 15.37 21.1605 13.9 19.9105 13M17.98 9.99C17.98 14.4028 14.4028 17.98 9.99 17.98C5.57724 17.98 2 14.4028 2 9.99C2 5.57724 5.57724 2 9.99 2C14.4028 2 17.98 5.57724 17.98 9.99Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
